import type { EventDetails } from "@/modules/eventDetails/client/api/types"

import { useQuery } from "@tanstack/react-query"
import { useParams } from "next/navigation"

import { getEventDetails } from "@/modules/eventDetails/client/api/getEventDetails"
import { getEventDetailsQueryKey } from "@/modules/eventDetails/client/api/getQueryKey"
import { useLocale } from "@/modules/locales/useLocale"
import { getBaseHost } from "@/modules/request"

export const useEventDetailsData = (): EventDetails | undefined => {
  const { eventSlug: slug } = useParams<{ eventSlug: string }>()
  const locale = useLocale()
  const hostname = typeof window !== "undefined" ? getBaseHost(window.location.host) : ""

  const { data } = useQuery({
    queryFn: () => getEventDetails({ hostname, locale, slug }),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getEventDetailsQueryKey({ slug }),
  })

  return data
}
